import React from "react";
import { PrimaryButton } from "../AllButtons/AllButtons";
import { Link, useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "@mui/material";
import FaildIcon from "../../assets/images/vactor/faild-icon.svg";
const PaymentFailure = () => {
  const [open, setOpen] = React.useState(true);
  const navigate = useNavigate();


  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="alert-dialog-wrapper">
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          Upgrade dialog
        </Button> */}
        <Dialog
          open={open}
          onClose={(event, reason) => {
            // Prevent closing on backdrop click or escape key
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              handleClose();
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="alert-dialog"
          disableEscapeKeyDown
        >
          <DialogContent>
            <div className="upgrade-dialog-body">
              <div className="upgrade-icon">
                <img src={FaildIcon} alt="" />
               
              </div>
              <div className="upgrade-dialog-title">Payment Failed!</div>
              <div className="upgrade-dialog-dsc">
                Something went wrong while processing your payment. Please try
                again or use a different payment method.
              </div>
             

              <div className="upgrade-action-btn">
                <PrimaryButton onClick={()=>{navigate("/price")}}>Try Again</PrimaryButton>
                <Link className="link-btn" to="/dashboard/help_center">
                  Contact Support
                </Link>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default PaymentFailure;